import rasEmerald96Src from './ras-emerald-96.svg';
export function Logo(props: React.ComponentPropsWithoutRef<'img'>) {
  return <img src={rasEmerald96Src} width={40} alt="RAS" {...props} />;
}

export function LogoSmall(props: React.ComponentPropsWithoutRef<'img'>) {
  return <img src={rasEmerald96Src} width={20} alt="RAS" {...props} />;
}
